import React from "react";
import { createPortal } from "react-dom";
import styles from "./Modal.module.scss";

interface ModalProps {
  modalOpen: boolean;
  closeModal: (value: boolean) => void;
  heading: React.ReactNode;
  children: React.ReactNode;
  doNotClose?: boolean;
  className?: string;
}

const Modal = ({
  modalOpen,
  closeModal,
  heading,
  children,
  doNotClose = false,
  className = "",
}: ModalProps) => {
  if (!modalOpen) return null;

  return createPortal(
    <div
      className={styles.mainContainer}
      onMouseDown={(e) => {
        e.stopPropagation();
        !doNotClose && closeModal(false);
      }}
    >
      <div
        className={`${styles.modalDiv} ${className}`}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className={styles.modalHeader}>
          <p>{heading}</p>
        </div>
        <div className={styles.modalBody}>{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
